@if (videoId()) {
  @if (cover() && !loadedMedias()) {
    <button class="relative w-full cursor-pointer" (click)="loadVideo()">
      <img
        [alt]="cover().alt || ''"
        [src]="cover().url | safeResourceUrl"
        loading="lazy"
        class="min-h-[390px] w-full slg:rounded-lg object-cover"
      />
      <nscf-video-play-background />
    </button>
  }

  @if (shouldDisplayYoutubePlayer()) {
    <youtube-player class="slg:rounded-lg overflow-hidden" #youtubePlayer [videoId]="videoId()" placeholderImageQuality="low" />
  }

  @if (legend()) {
    <nscf-legend [legend]="legend()" />
  }
}
